import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success:
          "border-transparent bg-green-500 text-white hover:bg-green-600",
        warning:
          "border-transparent bg-yellow-500 text-white hover:bg-yellow-600",
        info:
          "border-transparent bg-blue-500 text-white hover:bg-blue-600",
        purple:
          "border-transparent bg-purple-500 text-white hover:bg-purple-600",
        pink:
          "border-transparent bg-pink-500 text-white hover:bg-pink-600",
        orange:
          "border-transparent bg-orange-500 text-white hover:bg-orange-600",
        teal:
          "border-transparent bg-teal-500 text-white hover:bg-teal-600",
        gradient:
          "border-transparent bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 text-white",
        glassmorphism:
          "backdrop-filter backdrop-blur-lg bg-opacity-30 bg-white text-gray-800 border border-gray-200",
        outline_colored:
          "bg-transparent text-blue-500 border-2 border-blue-500 hover:bg-blue-50",
        soft:
          "bg-blue-50 text-blue-500 border-transparent hover:bg-blue-100",
        neon:
          "bg-black text-green-400 border-green-400 shadow-[0_0_2px_#00ff00,0_0_4px_#00ff00,0_0_6px_#00ff00] hover:shadow-[0_0_4px_#00ff00,0_0_8px_#00ff00,0_0_12px_#00ff00]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }